import React from "react";

const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-6 h-6 text-black"
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="16.5" y1="16.5" x2="22" y2="22" />
  </svg>
);

export default SearchIcon;